const BANNED_TAGS = new Set(['special_offer', '1st purchase', 'loyalty_tag'])

export const getStoreTags = (tags: string[]) => {
  if (!tags?.length) {
    return []
  }

  return tags.filter((tag) => !BANNED_TAGS.has(tag?.toLowerCase()))
}
